















import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class CheckIcon extends Vue {
    color = this.$store.direct.state.widget.color;
}
